import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Addtocart.css";
import { cartUtils, wishlistUtils } from "../utils/userCartWishlistUtils";
import axios from "axios";
import emailjs from "emailjs-com";
import Prefooterads from "../Homecomponents/Prefooterads";
import { CartItem, MobileCartItem, CheckoutSection } from "./CartComponents";
import ProgressLoader from "../Loader/ProgressLoader";
import Swal from "sweetalert2";
import { showMyAlert } from "../../utils/alertService";
import { getISTDateTime } from "../../utils/helpers";

const Addtocart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [showOrderConfirmAlert, setShowOrderConfirmAlert] = useState(false);
  const [showAlertRequiredFields, setShowAlertRequiredFields] = useState(false);
  const [productSizes, setProductSizes] = useState({});
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const userData = JSON.parse(sessionStorage.getItem("user"));
  const [address, setAddress] = useState(userData?.fullAddress || "");
  const [landmark, setLandmark] = useState(userData?.landmark || "");
  const [mobile2, setMobile2] = useState(userData?.mobile || "");
  const [pincode, setPincode] = useState(userData?.pincode || "");
  const navigate = useNavigate();

  const loadCartItems = async () => {
    try {
      const cart = cartUtils.getCart();      
      const productRes = await axios.get(
        "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList"
      );
      const allProducts = productRes.data;

      const items = Object.entries(cart).map(([cartItemKey, cartItem]) => {
        const product = allProducts.find((p) => p.id.toString() === cartItem.productId);
        if (!product) return null;
        let parsedVariants = [];
        try {
          parsedVariants = JSON.parse(product.variants || "[]");
        } catch (err) {
          console.warn("Invalid variant format for product:", product.productName);
        }

        const availableSizes = parsedVariants.map(
          (variant) => variant.variantUnit
        );
        const availableQuantities = {};
        const variantPrices = {};

        parsedVariants.forEach((variant) => {
          availableQuantities[variant.variantUnit] = parseInt(
            variant.stockQuantity || "0"
          );
          variantPrices[variant.variantUnit] = parseFloat(
            variant.price || product.sellingPrice
          );
        });

        return {
          ...product,
          cartItemKey,
          quantity: cartItem.quantity,
          size: cartItem.size,
          availableSizes,
          availableQuantities,
          variantPrices,
          parsedVariants,
        };
      }).filter((item) => item);
      setCartItems(items);
      const initialSizes = {};
      items.forEach(item => {
        if (item.size) {
          initialSizes[item.cartItemKey] = item.size;
        }
      });
      setProductSizes(initialSizes);
      
      setLoading(false);
    } catch (error) {
      console.error("Error loading cart items:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCartItems();
  }, []);

  useEffect(() => {
    const totalItems = cartItems.reduce(
      (sum, item) => sum + Number(item.quantity),
      0
    );

    if (totalItems <= 2) {
      setDeliveryCharge(80);
    } else if (totalItems <= 4) {
      setDeliveryCharge(120);
    } else {
      setDeliveryCharge(180);
    }
  }, [cartItems]);

  const handleRemoveFromCart = async (cartItemKey) => {
  const isConfirmed = await Swal.fire({
    title: "Remove this item?",
    icon: "warning",
    showCancelButton: true,
    heightAuto: false,
    padding: "8px 12px",
    customClass: {
      title: "swal-small-title",
      popup: "swal-small-popup",
      confirmButton: "swal-small-btn",
      cancelButton: "swal-small-btn"
    }
  }).then(r => r.isConfirmed);


    if (!isConfirmed) return;

    try {
      const success = await cartUtils.removeFromCart(cartItemKey);
      if (success) {
        setCartItems((prev) => prev.filter((item) => item.cartItemKey !== cartItemKey));
        setProductSizes((prev) => {
          const newSizes = { ...prev };
          delete newSizes[cartItemKey];
          return newSizes;
        });
      }
    } catch (error) {
      console.error("Error removing product from cart:", error);
    }
  };

  const handleMoveToWishlist = async (product) => {
    try {
      const wishlistSuccess = await wishlistUtils.addToWishlist(product.id);

      if (wishlistSuccess) {
        const cartSuccess = await cartUtils.removeFromCart(product.cartItemKey);
        if (cartSuccess) {
          setCartItems((prev) => prev.filter((item) => item.cartItemKey !== product.cartItemKey));
          setProductSizes((prev) => {
            const newSizes = { ...prev };
            delete newSizes[product.cartItemKey];
            return newSizes;
          });
        }
      } else {
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error moving to wishlist:", error);
    }
  };

  const handleQuantityChange = async (cartItemKey, newQuantity) => {
    if (newQuantity < 1) {
      await handleRemoveFromCart(cartItemKey);
      return;
    }

    try {
      const success = await cartUtils.updateQuantity(cartItemKey, newQuantity);
      if (success) {
        setCartItems((prev) =>
          prev.map((item) =>
            item.cartItemKey === cartItemKey ? { ...item, quantity: newQuantity } : item
          )
        );
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  const handleSizeChange = async (cartItemKey, newSize) => {
    try {
      const cartItem = cartItems.find(item => item.cartItemKey === cartItemKey);
      if (!cartItem) return;
      const success = await cartUtils.addToCart(
        cartItem.id, 
        cartItem.quantity, 
        newSize
      );
      if (success) {
        await cartUtils.removeFromCart(cartItemKey);
        loadCartItems();
      }
    } catch (error) {
      console.error("Error changing size:", error);
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const date = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${date}+${month}+${year}_${hours}${minutes}${seconds}`;
  };

const updateQuantityInSQLDB = async (productCode, quantity, itemPrice) => {  
  if (!productCode || !quantity || !itemPrice) {
    console.warn("updateQuantityInSQLDB → Missing productCode or quantity or item Price");
    return { status: "error", message: "Invalid input" };
  }

  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/index.php/api/update_quantity_in_db/${productCode}/${quantity}/${itemPrice}`;
    const response = await axios.get(url);
    const data = response?.data;
    if (!data) {
      console.error("Empty response from API");
      return { status: "error", message: "Empty API response" };
    }
    if (data.status === "success") {
      return {
        status: "success",
        item_code: data.item_code,
        reduced_by: data.reduced_by,
        new_stock: data.new_stock,
      };
    }
    if (data.status === "error") {
      console.warn(`Stock Update Error → ${data.message}`);
      return { status: "error", message: data.message };
    }
    console.warn("Unexpected API Response:", data);
    return { status: "error", message: "Unexpected API format" };
  } catch (error) {
    console.error("❌ Error updating SQL DB quantity:", error);
    return {
      status: "error",
      message: error.response?.data?.message || "Network/Server error",
    };
  }
};

  const updateProductQuantityInAPI = async (productId, size, newQuantity) => {
    try {
      const response = await axios.get(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList/${productId}`
      );
      const product = response.data;
      if (!product || !product.variants) {
        console.error("Product or variants not found.");
        return;
      }
      let variants = [];
      try {
        variants = JSON.parse(product.variants);
      } catch (err) {
        console.error("Failed to parse variants JSON:", err);
        return;
      }
      const variantIndex = variants.findIndex(
        (variant) => variant.variantUnit === size
      );
      if (variantIndex === -1) {
        console.error(`Variant size '${size}' not found in product ${productId}`);
        return;
      }
      const updatedQuantity = Math.max(0, newQuantity);
      variants[variantIndex].stockQuantity = updatedQuantity.toString();
      const updatedProduct = {
        ...product,
        variants: JSON.stringify(variants),
      };
      await axios.put(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList/${productId}`,
        updatedProduct
      );
      setCartItems((prev) =>
        prev.map((item) => {
          if (item.id === productId) {
            return {
              ...item,
              availableQuantities: {
                ...item.availableQuantities,
                [size]: updatedQuantity,
              },
            };
          }
          return item;
        })
      );
    } catch (error) {
      console.error("❌ Error updating product quantity:", error);
      throw error;
    }
  };

  const sendEmail = async (paymentData) => {
    const emailParams = {
      fullname: paymentData.get("user_fullname"),
      email: paymentData.get("user_email"),
      mobile: paymentData.get("user_mobile"),
      product: paymentData.get("product_name"),
      price: paymentData.get("paymentTotal"),
      bookingid: paymentData.get("bookingid"),
      razorPayID: paymentData.get("razorPayID"),
    };

    try {
      await emailjs.send(
        "service_kabqwp7",
        "template_9vlzohn",
        emailParams,
        "aJnP5PotDQdflEJWg"
      );
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleProceedToPay = async (razorpayPaymentId) => {
    const isFormValid = () => {
      const allSizesSelected = cartItems.every((item) => productSizes[item.cartItemKey]);
      return (
        address !== "" &&
        landmark !== "" &&
        pincode !== "" &&
        mobile2 !== "" &&
        deliveryCharge > 0 &&
        allSizesSelected
      );
    };

    if (!isFormValid()) {
      setShowAlertRequiredFields(true);
      return;
    }

    try {
      setShowOrderConfirmAlert(true);
      await Promise.all(
        cartItems.map(async (item) => {
          const selectedSize = productSizes[item.cartItemKey];
          if (!selectedSize) {
            throw new Error(`Please select a size for ${item.brandName}`);
          }

          const currentQuantity = parseInt(
            item.availableQuantities[selectedSize] || 0
          );
          const orderedQuantity = parseInt(item.quantity);

          if (currentQuantity < orderedQuantity) {
            throw new Error(
              `Not enough stock for size ${selectedSize} in ${item.brandName}`
            );
          }

          const itemPrice =
            item.variantPrices?.[selectedSize] || item.sellingPrice;

          const formData = new FormData();
          formData.append("user_id", userData.id);
          formData.append("user_fullname", userData.fullname);
          formData.append("user_email", userData.email);
          formData.append("user_mobile", userData.mobile);
          formData.append("product_id", item.id);
          formData.append("product_name", item.productName);
          formData.append("product_brand", item.brandName);
          formData.append("product_price", itemPrice);
          formData.append("product_quantity", item.quantity);
          formData.append("product_grand_total", (cartItems.reduce((acc, item) => {
            const selectedSize = productSizes[item.cartItemKey];
            const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
              ? item.variantPrices[selectedSize] 
              : item.sellingPrice;
            return acc + (item.quantity * itemPrice);
          }, 0) + deliveryCharge));
          formData.append("delivery_charge", deliveryCharge);
          formData.append("product_originalPrice", item.originalPrice || "");
          formData.append("product_image", item.productImage);
          formData.append("address", address);
          formData.append("landmark", landmark);
          formData.append("mobile2", mobile2);
          formData.append("pincode", pincode);
          formData.append("paymentTotal", (cartItems.reduce((acc, item) => {
            const selectedSize = productSizes[item.cartItemKey];
            const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
              ? item.variantPrices[selectedSize] 
              : item.sellingPrice;
            return acc + (item.quantity * itemPrice);
          }, 0) + deliveryCharge));
          formData.append("razorPayID", razorpayPaymentId);
          formData.append("status", "Order Placed");
          formData.append("date_time", getISTDateTime());
          formData.append("dress_size", selectedSize);
          formData.append("productCode", item.productCode || "");

          const secretId = `SECkalboq+${getCurrentDateTime()}+${String(
            new Date().getSeconds()
          ).padStart(2, "0")}`;

          const currentDate = new Date();
          const day = String(currentDate.getDate()).padStart(2, "0");
          const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
          const currentYear = currentDate.getFullYear();

          const newBookingId = `BIkalboq${day}${currentMonth}${currentYear}${String(
            Math.floor(Math.random() * 100)
          ).padStart(2, "0")}`;

          formData.append("bookingid", newBookingId);
          formData.append("secretId", secretId);

          await axios.post(
            "https://api.dremerz.net/api/Kalanjiyam_User_Order_Product_Checkout",
            formData
          );

          const newQuantity = currentQuantity - orderedQuantity;

          if (item.productCode) {
            await updateQuantityInSQLDB(item.productCode, orderedQuantity, itemPrice);
          }

          await updateProductQuantityInAPI(item.id, selectedSize, newQuantity);
          await sendEmail(formData);
        })
      );

      
      await cartUtils.clearCart();
      setCartItems([]);
      setProductSizes({});
      setTimeout(()=>{
        navigate("/TrackYourOrder/myOrders");
      },2000)
    } catch (error) {
      console.error("Error processing order:", error);
      showMyAlert({
        type: "danger",
        title: "Error",
        message: "Error processing your order. Please try again.",
        duration: 2500,   
      })
    }
  };

  const handlePayment = () => {
    const loadScript = (src) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });
    };

    loadScript("https://checkout.razorpay.com/v1/checkout.js").then(
      (loaded) => {
        if (!loaded) {

        showMyAlert({
          type: "danger",
          title: "Error",
          message: "Failed to load Razorpay SDK. Please check your connection.",
          duration: 2500,   
        })
          return;
        }

        const subtotal = cartItems.reduce((total, item) => {
          const selectedSize = productSizes[item.cartItemKey];
          const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
            ? item.variantPrices[selectedSize] 
            : item.sellingPrice;
          return total + (item.quantity * itemPrice);
        }, 0);

        const totalPayable = subtotal + deliveryCharge;

        const options = {
          key: "rzp_test_FNu62GtN5qZaVx",
          key_secret: "PRIExQVH2t9DAuFTyS4MIwF7",
          amount: Math.ceil(totalPayable) * 100,
          currency: "INR",
          name: "Kalanjiyam",
          description: "Order Payment",
          handler: async (response) => {
            await handleProceedToPay(response.razorpay_payment_id);
          },
          prefill: {
            name: userData.fullname,
            email: userData.email,
            contact: userData.mobile,
          },
          theme: {
            color: "#920504",
          },
        };

        const pay = new window.Razorpay(options);
        pay.open();
      }
    );
  };

  if (loading) {
    return (
      <>
        <div className="premium-container d-flex flex-column justify-content-center align-items-center mt-4">
          <div className="premium-loading">Loading your cart...</div>
          <ProgressLoader />
        </div>
      </>
    );
  }

  return (
    <div className="">
      <div className="premium-cart-container">
        <div className="premium-cart-header">
          <h1 style={{color: "#920504"}}>
            <i className="fa fa-shopping-cart"></i> My Cart
          </h1>
          {cartItems.length > 0 && (
            <span className="premium-cart-count">{cartItems.length} items</span>
          )}
        </div>

        {cartItems.length === 0 ? (
          <div className="premium-empty-cart">
            <div className="premium-empty-icon">
              <i className="fa fa-shopping-cart"></i>
            </div>
            <p>Your cart is empty</p>
            <button
              className="premium-continue-shopping"
              onClick={() => navigate("/")}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <div className="premium-cart-content">
            {/* Desktop View */}
            <div className="premium-cart-items-section">
              <div className="premium-cart-items-header">
                <h2>Cart Items</h2>
              </div>
              
              <div className="premium-cart-items-list">
                {cartItems.map((item) => (
                  <CartItem
                    key={item.cartItemKey}
                    item={item}
                    cartItemKey={item.cartItemKey}
                    onQuantityChange={handleQuantityChange}
                    onRemove={handleRemoveFromCart}
                    onMoveToWishlist={handleMoveToWishlist}
                    onProductClick={handleProductClick}
                    onSizeChange={handleSizeChange}
                    selectedSize={productSizes[item.cartItemKey] || item.size}
                  />
                ))}
              </div>
            </div>

            {/* Checkout Section */}
            <div className="premium-checkout-container">
              <CheckoutSection
                cartItems={cartItems}
                productSizes={productSizes}
                deliveryCharge={deliveryCharge}
                onProceedToPay={handlePayment}
                address={address}
                setAddress={setAddress}
                landmark={landmark}
                setLandmark={setLandmark}
                mobile2={mobile2}
                setMobile2={setMobile2}
                pincode={pincode}
                setPincode={setPincode}
                userData={userData}
              />
            </div>

            {/* Mobile View */}
            <div className="premium-mobile-cart-items">
              {cartItems.map((item) => (
                <MobileCartItem
                  key={item.cartItemKey}
                  item={item}
                  cartItemKey={item.cartItemKey}
                  onQuantityChange={handleQuantityChange}
                  onRemove={handleRemoveFromCart}
                  onMoveToWishlist={handleMoveToWishlist}
                  onProductClick={handleProductClick}
                  onSizeChange={handleSizeChange}
                  selectedSize={productSizes[item.cartItemKey] || item.size}
                />
              ))}
              
              <div className="premium-mobile-checkout">
                <CheckoutSection
                  cartItems={cartItems}
                  productSizes={productSizes}
                  deliveryCharge={deliveryCharge}
                  onProceedToPay={handlePayment}
                  address={address}
                  setAddress={setAddress}
                  landmark={landmark}
                  setLandmark={setLandmark}
                  mobile2={mobile2}
                  setMobile2={setMobile2}
                  pincode={pincode}
                  setPincode={setPincode}
                  userData={userData}
                />
              </div>
            </div>
          </div>
        )}

        {/* Login Alert Modal */}
        {showAlert && (
          <div className="premium-alert-overlay">
            <div className="premium-alert-modal">
              <div className="premium-alert-header">
                <h3>Login Required</h3>
                <button
                  type="button"
                  className="premium-alert-close"
                  onClick={() => setShowAlert(false)}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <div className="premium-alert-body">
                <p>Please login to continue.</p>
              </div>
              <div className="premium-alert-footer">
                <button
                  type="button"
                  className="premium-alert-btn secondary"
                  onClick={() => setShowAlert(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="premium-alert-btn primary"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        )}

        {showAlertRequiredFields && (
          <div className="premium-alert-overlay">
            <div className="premium-alert-modal">
              <div className="premium-alert-header">
                <h3>Info</h3>
                <button
                  type="button"
                  className="premium-alert-close"
                  onClick={() => setShowAlertRequiredFields(false)}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <div className="premium-alert-body">
                <p>Please fill all the required fields before proceeding to pay</p>
              </div>
              <div className="premium-alert-footer">
                <button
                  type="button"
                  className="premium-alert-btn primary"
                  onClick={() => {
                    setShowAlertRequiredFields(false);
                    document
                      .getElementById("checkout-section")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
        {showOrderConfirmAlert && (
          <div className="premium-alert-overlay">
            <div className="premium-alert-modal">
              <div className="premium-alert-header">
                <h3>Success</h3>
                <button
                  type="button"
                  className="premium-alert-close"
                  onClick={() => setShowOrderConfirmAlert(false)}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <div className="premium-alert-body">
                <p>Order Successfully Place, You will be redirected to My Order page.</p>
              </div>
              <div className="premium-alert-footer">
                <button
                  type="button"
                  className="premium-alert-btn primary"
                  onClick={() => {
                    setShowOrderConfirmAlert(false);
                    document
                      .getElementById("checkout-section")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Prefooterads />
    </div>
  );
};

export default Addtocart;